import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { captureException, setErrorContext } from '@tucan/utils/error-tracking'
import getApolloClient from '../../graphql/client'
import { allowStorage } from '../../utils/allow.storage'
import { ID } from '../../utils/id'
import { MessageInstance } from 'antd/es/message/interface'

export const companySlice = createSlice({
  initialState: () => {
    if (!allowStorage()) {
      return {
        id: undefined,
      }
    }

    return {
      id: localStorage.getItem('company') || undefined,
    }
  },
  name: 'company',
  reducers: {
    setCompanyId: (state, action: PayloadAction<{
      id: ID
      message: MessageInstance
    }>) => {
      const { message, id } = action.payload

      if (id) {
        getApolloClient().clearStore()
        try {
          localStorage.setItem('company', `${id}`)
        } catch (e) {
          captureException(e)
          void message.warning({
            content: 'There no storage available!',
          })
        }

        setErrorContext({ company: `${id}` })

        return {
          id,
        }
      } else {
        localStorage.removeItem('company')

        return {
          id: undefined,
        }
      }
    },
  },
})

export const { setCompanyId } = companySlice.actions

